import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Row, Col } from 'react-styled-flexboxgrid'

import FormItem from './FormItem'
import FormContainer from '../Form/Container'

const TABLE_SIZES = {
  address: {
    lg: 12,
    md: 12,
    sm: 12,
    xs: 12
  },
  city: {
    lg: 4,
    md: 4,
    sm: 4,
    xs: 12
  },
  state: {
    lg: 4,
    md: 4,
    sm: 4,
    xs: 6
  },
  zip: {
    lg: 4,
    md: 4,
    sm: 4,
    xs: 6
  }
}

@inject(all => ({
  payment: all.store.payment,
  user: all.store.auth.user,
  defaultPaymentMethod: all.store.payment.defaultPaymentMethod,
  hasDefaultPaymentMethod: all.store.payment.hasDefaultPaymentMethod,
  isAddingNewPaymentMethod: all.store.payment.isAddingNewPaymentMethod
}))
@observer
class UserAddressFormComponent extends Component {
  render() {
    return (
      <FormContainer>
        <Row>
          <Col {...TABLE_SIZES.address}>
            <FormItem
              id="billing street-address"
              targetKey="address"
              label="Street Address"
            />
          </Col>
        </Row>
        <Row>
          <Col {...TABLE_SIZES.city}>
            <FormItem
              targetKey="city"
              label="City"
              // placeholder="Brooklyn"
              id="billing city"
            />
          </Col>
          <Col {...TABLE_SIZES.state}>
            <FormItem
              targetKey="countryState"
              label="State"
              stateSelector
              id="billing state"
            />
          </Col>
          <Col {...TABLE_SIZES.zip}>
            <FormItem
              targetKey="zipcode"
              label="Zipcode"
              name="billing postal-code"
            />
          </Col>
        </Row>
      </FormContainer>
    )
  }
}

export default UserAddressFormComponent
